module.exports = __webpack_public_path__ + "static/media/shoprite-card-with-engagements.3f938cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shoprite-card-with-engagements.png
// module id = 134
// module chunks = 0